import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem("seva_lang") || "it");

    useEffect(() => {
        localStorage.setItem("seva_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const t = useCallback(
        (path) => {
            const value = path.split(".").reduce((obj, key) => obj?.[key], translations[lang]);
            return value ?? path;
        },
        [lang]
    );

    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
};
